module.exports = __webpack_public_path__ + "img/sake-zalmnigiri.44581704.png";